import { defineStore } from 'pinia'

export const useReferrerStore = defineStore('referrer', () => {
  const referrer = ref('')
  const currentPath = ref('')
  const routeName = ref('')

  const setReferrer = (value: string) => referrer.value = value

  const setCurrentPath = (value: string) => currentPath.value = value

  const setRouteName = (value: string) => routeName.value = value

  return {
    referrer,
    currentPath,
    routeName,
    setReferrer,
    setCurrentPath,
    setRouteName
  }
})